

export const About = () => {
  return (
    <div>
        <h1 className="text-6xl mb-4">Github API</h1>
        <p className='mb-4 text-2xl font-light'>
        A React app that consumes Githubs API to search user profiles and view details. Enjoy.
      </p>
    </div>
  )
}
